export function debounceAsync<
  Args extends any[],
  RType,
  T extends (...args: Args) => Promise<RType>,
>(func: T, delay: number): (...args: Args) => Promise<RType> {
  let timer: number | null = null;
  const resolvers: ((value: any) => any)[] = [];
  const rejecters: ((reason?: any) => any)[] = [];

  const debouncedFunc = function (...args: Args): Promise<RType> {
    return new Promise((resolve, reject) => {
      if (timer) {
        clearTimeout(timer);
      }

      resolvers.push(resolve);
      rejecters.push(reject);

      timer = window.setTimeout(async () => {
        const res = await func(...args);
        resolvers.forEach((r) => r(res));
      }, delay);
    });
  };

  return debouncedFunc;
}
